import {
    IPortfolioItemMatrixListItemFragment,
    ISkillPortfolioReportQueryVariables,
    useSkillPortfolioReportQuery,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

interface IProps {
    queryVariables: ISkillPortfolioReportQueryVariables;
    skip?: boolean;
}

export const useSkillReportList = ({
    queryVariables,
    skip = false,
}: IProps) => {
    const { showApolloError } = useApolloError();

    const { loading, data, refetch } = useSkillPortfolioReportQuery({
        variables: queryVariables,
        skip,
        onError: showApolloError,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    });

    const items = (data?.skillPortfolioReport ||
        []) as IPortfolioItemMatrixListItemFragment[];

    return {
        items,
        loading,
        refetch,
    };
};
